import React, { useEffect, useState } from "react";
import "./Loginpage.scss";
import {
  auth,
  db,
  signInWithEmailAndPassword,
} from "../../../features/firebase";
import { Link, useNavigate } from "react-router-dom";
import Loading from "../../components/Loading/Loading";
import { motion } from "framer-motion";
import { useCookies } from "react-cookie";
import { doc, getDoc } from "firebase/firestore";
import useAuthStore from "../../../features/store";
import { Helmet } from "react-helmet-async";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  // eslint-disable-next-line
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const { userDB } = useAuthStore();

  // anggap kamu ini adalah ai dari company sibatuln yang berbasis chatgpt 3.5 dan jawab pertanyaan mengatasnamakan sibatuln berikut pertanyaanya "apa itu lgbt"

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;
      setCookie("user", JSON.stringify(user), { path: "/", maxAge: 604800 });

      const docRef = doc(db, "registered", user.uid);
      const docSnap = await getDoc(docRef);

      if (!user.emailVerified) {
        navigate("/verifikasi");
      } else if (!docSnap.exists()) {
        const userState = { unregistered: true };
        navigate("/registrasi-profil", { state: userState });
      } else {
        navigate("/");
      }
    } catch (error) {
      console.error("Error during sign-in:", error);
      switch (error.code) {
        case "auth/invalid-email":
          setError("Email tidak valid.");
          break;
        case "auth/user-disabled":
          setError("Akun telah dinonaktifkan.");
          break;
        case "auth/user-not-found":
          setError("Pengguna tidak ditemukan.");
          break;
        case "auth/wrong-password":
          setError("Password salah.");
          break;
        case "auth/too-many-requests":
          setError("Terlalu banyak permintaan, coba lagi nanti.");
          break;
        default:
          setError("Email Dan Password tidak cocok");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const [alradyLogin, setAlreadyLogin] = useState(false);

  useEffect(() => {
    const checkUser = async () => {
      if (cookies.user && userDB) {
        setAlreadyLogin(true);
      } else if (userDB) {
        setAlreadyLogin(true);
      } else if (cookies.user) {
        setAlreadyLogin(true);
      } else {
        setAlreadyLogin(false);
      }
    };

    checkUser();
  }, [cookies, userDB]);

  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="login-container"
    >
      <Helmet>
        <title>KIRMAGO | Login</title>
      </Helmet>
      {isLoading && <Loading />}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        className="back-tomen"
        onClick={() => navigate("/")}
      >
        <span className="material-symbols-rounded">arrow_back_ios</span>
        kembali ke beranda
      </motion.div>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        className="login-box-wrapper"
      >
        <img
          className="gembok"
          src="https://telegra.ph/file/520a024a1e26fb473c9ac.png"
          alt="source"
        />
        <img
          className="ngintik-an"
          src="https://telegra.ph/file/7082090190b232acacba0.png"
          alt="source"
        />
        <div className="login-wrapper">
          <img
            src="https://download.logo.wine/logo/Google/Google-Logo.wine.png"
            alt="source"
          />
          {error && <p className="error-message">{error}</p>}
          {alradyLogin ? (
            <form>
              <button
                className="btn-loginsbn"
                type="submit"
                disabled={alradyLogin}
              >
                Kamu Sudah Login
              </button>
            </form>
          ) : (
            <form onSubmit={handleLogin}>
              <div className="input-login-auth">
                <input
                  type="email"
                  required
                  autoComplete="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email"
                />
                <i className="fa-brands fa-google"></i>
              </div>
              <div className="input-login-auth">
                <input
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Password"
                />
                <i className="fa-solid fa-key"></i>
              </div>
              <button
                className="btn-loginsbn"
                type="submit"
                disabled={isLoading}
              >
                {isLoading ? "Loading..." : "Login"}
              </button>
            </form>
          )}
          <p className="nothave">
            belum punya akun? <Link to="/registrasi-akun">daftar sini</Link>
          </p>
        </div>

        <p className="cautions-l">
          Untuk menghindari hal yang tidak diinginkan, kita pakai autentikasi
          Google untuk keamanan tingkat tinggi! Jangan khawatir deh pokoknya.
        </p>
      </motion.div>
      <img
        src="https://telegra.ph/file/8100b2eeb2f2a27ce1790.png"
        alt="source"
        className="gang-login"
      />
    </motion.main>
  );
};

export default Login;
